var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5526_567)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 79.5,
    height: 79.5,
    rx: 21.75,
    stroke: "#4D4D4D",
    strokeOpacity: 0.45,
    strokeWidth: 2.5,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4617 37.2063L43.4555 25.2143C43.4024 24.383 43.0347 23.6031 42.4271 23.0331C41.8196 22.4632 41.0179 22.146 40.1848 22.146C39.3518 22.146 38.5501 22.4632 37.9425 23.0331C37.335 23.6031 36.9673 24.383 36.9142 25.2143L36.908 37.2063L24.8866 37.2047C24.4561 37.2047 24.0298 37.2895 23.632 37.4543C23.2343 37.619 22.8729 37.8605 22.5684 38.165C22.264 38.4694 22.0225 38.8308 21.8578 39.2285C21.693 39.6263 21.6082 40.0526 21.6082 40.4831C21.6082 40.9137 21.693 41.34 21.8578 41.7377C22.0225 42.1355 22.264 42.4969 22.5684 42.8013C22.8729 43.1057 23.2343 43.3472 23.632 43.512C24.0298 43.6767 24.4561 43.7615 24.8866 43.7615L36.908 43.76L36.9126 55.7504C36.8877 56.1956 36.9538 56.6411 37.107 57.0598C37.2602 57.4785 37.4972 57.8615 37.8035 58.1854C38.1098 58.5094 38.479 58.7674 38.8884 58.9438C39.2979 59.1201 39.739 59.2111 40.1848 59.2111C40.6307 59.2111 41.0718 59.1201 41.4813 58.9438C41.8907 58.7674 42.2599 58.5094 42.5662 58.1854C42.8725 57.8615 43.1095 57.4785 43.2627 57.0598C43.4159 56.6411 43.482 56.1956 43.4571 55.7504L43.4617 43.76L55.446 43.7615C56.3155 43.7615 57.1493 43.4161 57.7642 42.8013C58.379 42.1865 58.7244 41.3526 58.7244 40.4831C58.7244 39.6136 58.379 38.7798 57.7642 38.165C57.1493 37.5501 56.3155 37.2047 55.446 37.2047L43.4617 37.2063Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5526_567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUpload);
export default __webpack_public_path__ + "static/media/new-upload.aacb179538cff23f788d57b117b76dbb.svg";
export { ForwardRef as ReactComponent };